import CartHandler from "./handlers/CartHandler";

/**
 * DiscountManager – Shopify Discount & Gift Product Handler
 *
 * This function handles discount code validation in a Shopify storefront,
 * adds promotional gift products to the cart based on discount rules,
 * and updates the gift product elements in the DOM to prevent user manipulation.
 *
 * Features:
 *  - Captures discount code from a form submission.
 *  - Sends cart data to a custom API to validate discount code and retrieve gift products.
 *  - Automatically adds applicable gift product variants to the cart.
 *  - Waits for gift product cards to appear in the DOM and disables interaction.
 *
 * Assumptions:
 *  - Form has class `.discount-box-form`.
 *  - Discount input has ID `slidecart_discount_code`.
 *  - Gift product DOM elements include a `data-variant-id` attribute.
 *
 */

(async () => {
  try {
    const cartOptimizer = new CartHandler();
    await cartOptimizer.initialize();
  } catch (error) {
    console.error("Error initializing DiscountManager:", error);
    return;
  }
})();